<!-- eslint-disable vue/no-v-html -->
<script>
import { defineComponent } from "@vue/composition-api";
import useState from "./use-state";

export default defineComponent({
  name: "Table",
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["on-modify-mailbox"],
  setup(props, { emit }) {
    const { columns } = useState();

    // 编辑邮箱
    const handleModifyMailbox = (val) => {
      emit("on-modify-mailbox", val);
    };

    return {
      columns,
      handleModifyMailbox,
    };
  },
});
</script>

<template>
  <div class="table">
    <a-table row-key="id" :columns="columns" :data-source="dataSource" :pagination="false">
      <span slot="mailHeader" slot-scope="text, record">
        <span class="mail-header" v-html="record.mailHeader"></span>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button type="link" @click="handleModifyMailbox(record)">编辑</a-button>
      </span>
    </a-table>
  </div>
</template>

<style lang="less" scoped>
.mail-header {
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  text-align: left;
  word-wrap: break-word;

  .html-content {
    line-height: 24px;
    word-break: break-all;
  }
}
</style>
